import { Observable } from 'rxjs';
import { RESELLER } from '../../app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';

import { AuthService } from '../auth.service';

@Injectable()
export class ResellerApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  addReseller(
    body: any
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}${RESELLER}`,
      body,
      this.authHeader
    );
  }
}
